import React from "react";
import { Link } from "react-router-dom";

const FooterSection = () => {
  // Links with route mapping: null = coming soon (no page yet)
  const links = {
    Services: [
      { label: "Ride-Hailing", to: "/customer-booking-screen" },
      { label: "Parcel Delivery", to: "/customer-booking-screen" },
      { label: "Food Delivery", to: null },
      { label: "Fleet Investment", to: "/#invest", scroll: "invest" },
      { label: "OnTheGo Pay", to: "/payments-wallet-screen" },
    ],
    Company: [
      { label: "About Us", to: null },
      { label: "Careers", to: null },
      { label: "Press & Media", to: null },
      { label: "Blog", to: null },
      { label: "Investors", to: null },
    ],
    Support: [
      { label: "Help Center", to: null },
      { label: "Safety", to: null },
      { label: "Contact Us", to: null },
      { label: "Report an Issue", to: null },
      { label: "Driver Support", to: "/driver-onboarding-screen" },
    ],
    Legal: [
      { label: "Privacy Policy", to: null },
      { label: "Terms of Service", to: null },
      { label: "Cookie Policy", to: null },
      { label: "Accessibility", to: null },
    ],
  };

  const cities = ["Nairobi", "Kampala", "Lagos", "Dar es Salaam", "Accra", "Kigali", "Addis Ababa", "Lusaka"];

  const socials = [
    { icon: "𝕏", label: "Twitter/X", href: "https://twitter.com" },
    { icon: "f", label: "Facebook", href: "https://facebook.com" },
    { icon: "in", label: "LinkedIn", href: "https://linkedin.com" },
    { icon: "▶", label: "YouTube", href: "https://youtube.com" },
    { icon: "📸", label: "Instagram", href: "https://instagram.com" },
  ];

  return (
    <footer style={{ background: "#060e1a", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
      {/* Main footer content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-2">
            {/* Logo */}
            <div className="flex items-center gap-3 mb-6">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center font-black text-[#0a1628] text-sm"
                style={{ background: "linear-gradient(135deg, #ffd700, #f59e0b)" }}
              >
                OG
              </div>
              <div>
                <div className="text-white font-black text-lg leading-none">OnTheGo</div>
                <div className="text-white/25 text-xs">Deliveries & Taxi</div>
              </div>
            </div>

            <p className="text-white/35 text-sm leading-relaxed mb-6 max-w-xs">
              Africa's smart mobility super app. Connecting riders, drivers, and businesses across the continent — one trip at a time.
            </p>

            {/* Cities */}
            <div className="mb-7">
              <div className="text-white/25 text-xs uppercase tracking-widest mb-3 font-medium">Available in</div>
              <div className="flex flex-wrap gap-2">
                {cities?.map((city) => (
                  <span
                    key={city}
                    className="px-2.5 py-1 rounded-lg text-xs text-white/35 border"
                    style={{ borderColor: "rgba(255,255,255,0.08)" }}
                  >
                    {city}
                  </span>
                ))}
              </div>
            </div>

            {/* Social links */}
            <div className="flex gap-2.5">
              {socials?.map((social) => (
                <a
                  key={social?.label}
                  href={social?.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social?.label}
                  className="w-9 h-9 rounded-xl flex items-center justify-center text-white/30 text-sm font-bold transition-all duration-300 hover:text-[#ffd700] hover:scale-110"
                  style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
                  onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(255,215,0,0.3)"; e.currentTarget.style.background = "rgba(255,215,0,0.08)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.08)"; e.currentTarget.style.background = "rgba(255,255,255,0.04)"; }}
                >
                  {social?.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Links columns */}
          {Object.entries(links)?.map(([category, items]) => (
            <div key={category}>
              <div className="text-white/50 text-xs font-bold uppercase tracking-widest mb-5">
                {category}
              </div>
              <ul className="space-y-3">
                {items?.map((item) => (
                  <li key={item?.label}>
                    {item?.to ? (
                      item?.scroll ? (
                        <a
                          href={`#${item?.scroll}`}
                          onClick={(e) => { e?.preventDefault(); document.querySelector(`#${item?.scroll}`)?.scrollIntoView({ behavior: "smooth" }); }}
                          className="text-white/40 text-sm transition-colors duration-200 hover:text-white/70"
                        >
                          {item?.label}
                        </a>
                      ) : (
                        <Link
                          to={item?.to}
                          className="text-white/40 text-sm transition-colors duration-200 hover:text-white/70"
                        >
                          {item?.label}
                        </Link>
                      )
                    ) : (
                      <span className="text-white/20 text-sm flex items-center gap-1.5">
                        {item?.label}
                        <span
                          className="text-[9px] font-bold px-1.5 py-0.5 rounded"
                          style={{ background: "rgba(255,215,0,0.1)", color: "rgba(255,215,0,0.5)" }}
                        >
                          Soon
                        </span>
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* Bottom bar */}
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-white/20 text-xs">
            © 2025 OnTheGo Deliveries & Taxi Ltd. All rights reserved.
          </div>
          <div className="flex items-center gap-2">
            <span className="text-white/20 text-xs">Powered by</span>
            <span
              className="text-xs font-bold px-2.5 py-0.5 rounded-lg"
              style={{ background: "linear-gradient(135deg, #ffd700, #f59e0b)", color: "#0a1628" }}
            >
              OnTheGo Pay
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/20 text-xs">
            <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
            All systems operational
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
